import React from 'react';

import { useEventTypeEvaluationsContext } from '../context';
import { TransactionHistoryTable } from '../../transaction/history/TransactionHistoryTable/TransactionHistoryTable';

const RecentTransactions = () => {
  const { entity } = useEventTypeEvaluationsContext();

  return (
    <TransactionHistoryTable entityToken={entity.entity_token} />
  );
};

export default RecentTransactions;
